// src/components/BattleScreen/BattleAnimations/TackleAnimation.jsx
import { useEffect } from 'react';
import './TackleAnimation.css';




export default function TackleAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl   = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    // 1) Compute center-to-center vector
    const p = playerEl.getBoundingClientRect();
    const o = opponentEl.getBoundingClientRect();
    const dx = (o.left + o.width/2) - (p.left + p.width/2);
    const dy = (o.top  + o.height/2) - (p.top  + p.height/2);

    // 2) Prep sprite transition
    playerEl.style.transition = 'transform 0.3s ease, filter 0.2s ease';
    playerEl.style.transform = 'translate(0, 0)';
    
    // 3) Next frame: charge forward
    requestAnimationFrame(() => {
      playerEl.style.transform = `translate(${dx}px, ${dy}px)`;
    });

    // 4) At 300ms: flash + spawn sparks
    const hitTimer = setTimeout(() => {
      // flash
      playerEl.style.filter = 'brightness(2)';
      setTimeout(() => { playerEl.style.filter = ''; }, 200);

      // spawn multiple sparks
      const container = playerEl.parentElement; // .battle-bg
      const containerRect = container.getBoundingClientRect();
      const centerX = (o.left + o.width/2) - containerRect.left;
      const centerY = (o.top  + o.height/2) - containerRect.top;

      const sparks = [];
      for (let i = 0; i < 8; i++) {
        const spark = document.createElement('div');
        spark.className = 'spark-anim';
        spark.style.left = `${centerX}px`;
        spark.style.top  = `${centerY}px`;

        // random direction + distance
        const angle = Math.random() * 2 * Math.PI;
        const dist  = 20 + Math.random() * 20;
        spark.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
        spark.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);

        container.appendChild(spark);
        sparks.push(spark);
      }

      // remove sparks after their animation
      setTimeout(() => {
        sparks.forEach(s => s.remove());
      }, 600);
    }, 300);

    // 5) At 600ms: slide back home
    const returnTimer = setTimeout(() => {
      playerEl.style.transform = '';
    }, 600);

    // 6) At 900ms: cleanup & notify parent
    const doneTimer = setTimeout(() => {
      playerEl.style.transition = '';
      onComplete();
    }, 900);

    return () => {
      clearTimeout(hitTimer);
      clearTimeout(returnTimer);
      clearTimeout(doneTimer);
      playerEl.style.transform  = '';
      playerEl.style.filter     = '';
      playerEl.style.transition = '';
      // ensure no stray sparks remain
      document.querySelectorAll('.spark-anim').forEach(el => el.remove());
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

